import styled from 'styled-components'

export const DataTransContainer = styled.div`
  display: none;
`
